const voteTypes = {
	UP: {
		type: 'UP'
	},
	NEUTRAL: {
		type: 'NEUTRAL'
	},
	DOWN: {
		type: 'DOWN'
	}
}

export default voteTypes



// WEBPACK FOOTER //
// ./src/enums/voteTypes.js